import { Controller } from "stimulus"
import Utility from "../classes/Utility";

class NavController extends Controller {
  static targets = [
    'navContainer'
  ]

  connect() {
    this.mobileNav = document.querySelector('.n-nav__mobile');
    if(this.__isMobileDevice()) {
      if(this.hasNavContainerTarget) {
        this.navContainerTarget.classList.remove('t-container');
      }
      this.mobileNav.classList.add('t--left-screen');
      this.mobileNav.classList.add('t-flex');
      this.mobileNav.classList.remove('t-hidden');
    }
  }

  triggerNav() {
    const overlay = document.querySelector('.background-drop-overlay');
    const mobileNavPosition = Utility.isScreenSizeOf('md', true) ? 't--left-64' : 't--left-screen';
    this.mobileNav.classList.toggle('t-left-0');
    this.mobileNav.classList.toggle(mobileNavPosition);
    this.mobileNav.classList.toggle('t-shadow-2xl');
    overlay.classList.toggle('t-hidden');
    document.body.classList.toggle('t-overflow-y-hidden');
    document.body.classList.toggle('t-fixed'); 
  }

  __isMobileDevice() {
    return ['m', 't'].includes(Utility.getDeviceType());
  }
}

export default NavController;
